/**
 * Clipboard Helper
 *
 * @package
 */

/**
 * Copy text to the clipboard, falling back to a hidden textarea and
 * document.execCommand on browsers without the async Clipboard API
 * (or when it rejects, e.g. outside a secure context).
 *
 * @param {string} text Text to copy.
 * @return {Promise<boolean>} Resolves true when the copy succeeded.
 */
export const copyToClipboard = async text => {
	if ( ! text ) {
		return false;
	}

	if ( navigator.clipboard ) {
		try {
			await navigator.clipboard.writeText( text );
			return true;
		} catch ( error ) {
			// Rejected (e.g. insecure context); fall through to execCommand.
		}
	}

	const textArea = document.createElement( 'textarea' );
	textArea.value = text;
	textArea.style.position = 'fixed';
	textArea.style.opacity = '0';
	document.body.appendChild( textArea );
	textArea.select();

	let copied = false;
	try {
		copied = document.execCommand( 'copy' );
	} catch ( error ) {
		// Unsupported; copied stays false.
	}

	document.body.removeChild( textArea );

	return copied;
};
